import { Tabs as TabsAtnd } from 'antd';
import PropTypes from 'prop-types';
import React from "react";

const Tabs = ({ list }) => {
    return <TabsAtnd defaultActiveKey={list?.[0]?.key} items={list} />

}

Tabs.propTypes = {
    list: PropTypes.array,
    // stateChanger :PropTypes.func
}

export default Tabs
